<app-report (onReady)="onReady()"
            [form]="form"
            [iframe]="iframe$ | async"
            [enableDialogs]="true">
  <ng-container actions>
  </ng-container>
  <app-ad-reports-table [options]="requestOptions$ | async"></app-ad-reports-table>
</app-report>
